export const truck = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber.',
    'Giant Vents Make the Air Flow Smoothly.',
  ],
  'material': [
    'Rubber: Premium Nature Rubber.',
    'Steel: SGCC, Electrostatic Powder Coating.',
    'Rivet: SUS302',
    'Plastic: Spacer & Adapter: POM',
    'Stainless Steel Backing: SUS304ES',
  ],
  'featureIcons': ["02", "03"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "22", "mm": "560", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "1.2" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "1.2" }
  ],
  'adapters': ["f1", "f2", "f4", "u3a", "u4a"]
}